import "./styles.css";

import {
  NavLink,
  Outlet,
  Route,
  useLoaderData,
  useLocation,
  useMatch,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import GenericErrorDisplay, { ErrorMessageContext } from "../generic-error";
import useAuth, { useIsAuth, useLogout } from "../../auth/hooks";
import { useEffect, useState } from "react";
import { path as loginPath } from "../page-login";
import TransmedProcessService from "../../service/transmed/process";
import TransmedAdmin from "../../dtos/transmed/process/admin";

import * as PageUser from "./page-user";
import * as PageValidation from "./page-validation";
import * as PageTransmedEdition from "./page-transmed-edition";
import * as PageTransmedStaff from "./page-transmed-staff";
import * as PageTransmedForm from "./page-transmed-form";
import * as PageTransmedReceivings from "./page-transmed-receivings";
import * as PageTransmedCalendar from "./page-transmed-calendar";
import * as PageTransmedRegistrations from "./page-transmed-registrations";
import * as PageTransmedContestations from "./page-transmed-contestations";
import * as PageTransmedIncomings from "./page-transmed-incomings";
import * as PageTransmedDistribution from "./page-transmed-distribution";
import * as PageTransmedDistributionAll from "./page-transmed-distribution-all";
import * as PageTransmedProof from "./page-transmed-proof";
// import * as PageTransmedCertificate from "./page-transmed-certificate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export const path = "/account/";

export async function loader() {
  const transmedAdmin = new TransmedProcessService().read.admin();
  return [await transmedAdmin];
}

export function Component() {
  const [transmedAdmin] = useLoaderData() as [TransmedAdmin];
  const isAuth = useIsAuth();
  const auth = useAuth();
  const logout = useLogout();
  const { width } = useWindowDimensions();

  const matchIndex = useMatch(path);
  const location = useLocation();
  const isIndex = matchIndex && matchIndex.pathname === location.pathname;

  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    if (!isAuth() && auth === null) navigate(loginPath, { replace: true });
  }, [navigate, isAuth, auth]);

  const heightCalc =
    "calc(100dvh - var(--nav-height) - calc(2 * var(--gap)) - calc(2 * var(--surface-padding)))";

  const nav = (
    <nav
      className="surface"
      style={{
        height: heightCalc,
        flex: width > 480 ? "0 1 220px" : "1 1 220px",
        position: "sticky",
        top: "calc(var(--nav-height) + var(--gap))",

        alignSelf: "flex-start",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "stretch",
      }}
    >
      <div
        className="inline-scrollbar y"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "stretch",
          paddingRight: "var(--surface-padding)",
          gap: "var(--gap-xs)",
        }}
      >
        <NavLink
          className={(props: { isActive: boolean; isPending: boolean }) =>
            `button primary ${
              props.isActive || props.isPending ? "outlined" : "text"
            }`
          }
          to={PageUser.path}
        >
          Contul meu
        </NavLink>
        {transmedAdmin.lc !== null && (
          <>
            <hr />
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageValidation.path}
            >
              Validare conturi
            </NavLink>
          </>
        )}
        {transmedAdmin.national_coordinator && (
          <>
            <hr />
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedEdition.path}
            >
              Ediție transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedForm.path}
            >
              Formular transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedStaff.path}
            >
              Staff transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedReceivings.path}
            >
              Locuri transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedDistributionAll.path}
            >
              Distribuție transmed
            </NavLink>
            {/* <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedCertificate.path}
            >
              Diplome transmed
            </NavLink> */}
          </>
        )}
        {transmedAdmin.lc !== null && (
          <>
            <hr />
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedCalendar.path}
            >
              Informații transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedRegistrations.path}
            >
              Înscrieri transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedContestations.path}
            >
              Contestații transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedDistribution.path}
            >
              Distribuție transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedIncomings.path}
            >
              Participanți transmed
            </NavLink>
            <NavLink
              className={(props: { isActive: boolean; isPending: boolean }) =>
                `button primary ${
                  props.isActive || props.isPending ? "outlined" : "text"
                }`
              }
              to={path + PageTransmedProof.path}
            >
              Validarea participării
            </NavLink>
          </>
        )}
        <div className="stretcher" />
        <hr />
        <button
          className="button primary text"
          style={{ textAlign: "left", ...{ "--color": "red" } }}
          onClick={() => {
            navigate(path);
            logout();
          }}
        >
          Ieși din cont
        </button>
      </div>
    </nav>
  );

  const content = (
    <div
      className="surface"
      style={{
        minHeight: heightCalc,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "stretch",
        gap: "var(--gap-medium)",
        color: "var(--color-dark)",
        position: "relative",
      }}
    >
      {errorMessage.length > 0 && (
        <div
          className="surface"
          style={{
            backgroundColor: "red",
            position: "sticky",
            top: "calc(var(--nav-height) + var(--gap-small))",
            zIndex: 2,
            color: "white",

            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "var(--box-shadow-xs)",
          }}
        >
          {errorMessage}
          <button
            className="primary button text"
            style={{
              color: "white",
            }}
            onClick={() => setErrorMessage("")}
          >
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
      )}
      <Outlet />
    </div>
  );

  return (
    <ErrorMessageContext.Provider value={[errorMessage, setErrorMessage]}>
      <div
        id="page-account"
        style={{
          ...{
            "--gap": "var(--gap-small)",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "stretch",
          alignSelf: "stretch",
          flex: 1,
          position: "relative",
          padding: "var(--gap)",
          gap: "var(--gap)",
          width: "calc(100% - 2 * var(padding))",
        }}
      >
        {width > 768 ? (
          <>
            {nav}
            {content}
          </>
        ) : isIndex ? (
          <>
            {nav}
            {width > 480 && content}
          </>
        ) : (
          content
        )}
      </div>
    </ErrorMessageContext.Provider>
  );
}
Component.displayName = "page-account";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-account-error";

export const children = [
  <Route
    index
    element={
      <h3
        style={{
          flex: 1,
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faChevronCircleLeft}
          style={{ marginRight: "var(--gap-medium)" }}
          color="var(--color-fasmr-blue)"
        />
        Alege o opțiune din listă
      </h3>
    }
  />,
  <Route {...PageUser} />,
  <Route {...PageValidation} />,
  <Route {...PageTransmedEdition} />,
  <Route {...PageTransmedStaff} />,
  <Route {...PageTransmedForm} />,
  <Route {...PageTransmedReceivings} />,
  <Route {...PageTransmedCalendar} />,
  <Route {...PageTransmedRegistrations} />,
  <Route {...PageTransmedContestations} />,
  <Route {...PageTransmedDistribution} />,
  <Route {...PageTransmedDistributionAll} />,
  <Route {...PageTransmedIncomings} />,
  <Route {...PageTransmedProof} />,
  // <Route {...PageTransmedCertificate} />,
];
